<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Joseph
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>To teach that God controls the events of human history and is able to make the future known.</li>
                        <li>To teach that despite circumstances, God is always with his people to bless them.</li>
                        <li>To understand that God rules over sinful human behaviour to achieve his great plan for the world.</li>
                        <li>To understand that God's plans bring forgiveness and restored relationships.</li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series follows Joseph's journey from being the favoured son in his father's household to being nothing more than a slave,
                        falsely accused and forgotten in a prison in Egypt. From that hopeless situation, God acts to not only rescue Joseph,
                        but make him the most important man in the world. Here he is uniquely positioned to save the lives of many people,
                        not least of all his own family who had rejected him many years before.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>Lesson 1 - Chosen but Rejected (Genesis 37:1-36)</p>
                    <p>Lesson 2 - Rejected but Blessed (Genesis 39:1-23)</p>
                    <p>Lesson 3 - Puzzling but Plain (Genesis 40:1 - 41:57)</p>
                    <p>Lesson 4 - Together but Apart (Genesis 42:1 - 44:34)</p>
                    <p>Lesson 5 - Rejected but Reconciled (Genesis 45:1 - 47:12)</p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Joseph",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Joseph`,
            meta: [
                {
                    name: 'description',
                    content: "To teach that God controls the events of human history and is able to make the future known.",
                },
            ],
        };
    },
};
</script>
